import React, { useState } from 'react'
import { Wrapper } from './style'
import { QuicksaveInput } from 'src/components/Global/Input/Input'
import { action } from 'typesafe-actions'
import { useDispatch } from 'react-redux'
import { PlanTypes } from 'src/redux/types/planTypes'
import { ModalButton } from 'src/components/Global/Button/Button'
import { PlanTypeModal } from './plans-redux-modal/PlanType'
import { ToastContainer, toast } from 'react-toastify'
import { ModalTitleText } from 'src/components/Global/Text/TitleText'
import 'react-toastify/dist/ReactToastify.css'
const PlanAmount = () => {
  const [planData, setPlanData] = useState({
    amount_to_save: '',
  })
  const payload = {
    planName: {
      ...planData,
    },
  }
  const [showModal, setShowModal] = useState(false)
  const createPlan = (e: any) => {
    e.preventDefault()
    if (!amount_to_save) {
      toast.warn('Amount can not be empty!', {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      return
    }
    setShowModal(true)
  }
  const dispatch = useDispatch()
  const { amount_to_save } = planData

  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...planData }
    newData[name] = value
    setPlanData(newData)
    dispatch(action(PlanTypes._UPDATE_PLAN_FORM, newData))
  }
  const Disabled = () => {
    if (!amount_to_save) {
      return 'blur'
    }
    return null
  }
  return (
    <Wrapper>
      <div className="pageNumber"></div>
      <form className="content">
        <div className="top-form">
          <ModalTitleText>Amount to save</ModalTitleText>
          <p className="desc">How much do you want to save?</p>
          <QuicksaveInput
            type="number"
            name="amount_to_save"
            value={amount_to_save}
            placeholder="100,000"
            onChange={handleChange}
          />
        </div>
        <PlanTypeModal showModal={showModal} setShowModal={setShowModal} />
        <div>
          <ModalButton onClick={createPlan} className={`button ${Disabled()}`}>
            Continue
          </ModalButton>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanAmount }
